import { useState } from 'react'

let ipCountry: Promise<string | undefined> | undefined

const fetchGeolocation = async () => {
  if (typeof window === 'undefined') {
    return
  }
  const res = await fetch('/api/geolocate')
  return res.text()
}

const useGeolocation = () => {
  const [country, setCountry] = useState<string>()
  if (ipCountry === undefined) {
    ipCountry = fetchGeolocation()
  }
  void ipCountry.then(c => {
    if (country !== c) {
      setCountry(c)
    }
  })
  return country
}

export default useGeolocation
